module.exports = __webpack_public_path__ + "static/media/settings-background-image-kmm.0a0c6ca2.png";